/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckLoginRequestApiRoaming } from '../../models/check-login-request-api-roaming';
import { RoamingDataApiRoaming } from '../../models/roaming-data-api-roaming';

export interface ApiRoamingCheckLoginAppPhonePost$Params {
  lang?: string;
      body?: CheckLoginRequestApiRoaming
}

export function apiRoamingCheckLoginAppPhonePost(http: HttpClient, rootUrl: string, params?: ApiRoamingCheckLoginAppPhonePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RoamingDataApiRoaming>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingCheckLoginAppPhonePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoamingDataApiRoaming>;
    })
  );
}

apiRoamingCheckLoginAppPhonePost.PATH = '/api/Roaming/CheckLoginAppPhone';
